/**
 * Marketing-site cookie preference storage (localStorage).
 * Used by /cookies and can gate future analytics/ad scripts once added.
 */
export const COOKIE_PREFS_STORAGE_KEY = "cg_cookie_prefs";

export const defaultCookiePreferences = {
  performance: true,
  functional: true,
  advertising: false,
};

export function getCookiePreferences() {
  if (typeof window === "undefined") {
    return { ...defaultCookiePreferences };
  }
  try {
    const raw = window.localStorage.getItem(COOKIE_PREFS_STORAGE_KEY);
    if (!raw) return { ...defaultCookiePreferences };
    const parsed = JSON.parse(raw);
    return { ...defaultCookiePreferences, ...parsed };
  } catch {
    return { ...defaultCookiePreferences };
  }
}

export function setCookiePreferences(prefs) {
  try {
    window.localStorage.setItem(COOKIE_PREFS_STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    /* quota / private mode */
  }
}
